import { Button, ButtonGroup, Typography, darken, useTheme, alpha } from '@mui/material'
import { Google as GoogleIcon, SmartToy as RobotIcon } from '@mui/icons-material'

const SourceToggle = ({ props: viewProps = {}, controls = {} }) => {
  const theme = useTheme()
  const { dataSource, compact = false, showLabels = false } = viewProps
  const { onChange } = controls

  const labeled = Boolean(showLabels) && !compact
  const isGoogle = dataSource === 'google'
  const isN8n = dataSource === 'n8n'
  const hairline = alpha('#fff', 0.14)

  return (
    <ButtonGroup
      fullWidth={false}
      sx={{
        borderRadius: 1.25,
        overflow: 'hidden',
        border: `1px solid ${hairline}`,
        backgroundColor: alpha('#000', 0.28),
        boxShadow: 'none',
        minHeight: labeled ? 32 : 30,
        flexShrink: 0,
        '& .MuiButtonGroup-grouped': {
          borderColor: hairline,
          '&:not(:last-of-type)': {
            borderRightColor: hairline
          }
        },
        '& .MuiButton-root': {
          borderRadius: 0,
          py: labeled ? 0.35 : 0.3,
          px: labeled ? 0.9 : 0.55,
          minWidth: labeled ? 72 : 30,
          minHeight: labeled ? 30 : 28,
          gap: labeled ? 0.4 : 0,
          textTransform: 'none',
          fontWeight: 800,
          letterSpacing: 0.15,
          borderWidth: 0,
          '&.MuiButton-outlined': {
            borderWidth: 0
          }
        }
      }}
    >
      <Button
        onClick={() => { onChange('google') }}
        variant={isGoogle ? 'contained' : 'text'}
        aria-pressed={isGoogle}
        aria-label='Google Sheet data source'
        sx={{
          flex: '0 0 auto',
          backgroundColor: isGoogle ? theme.palette.success.main : 'transparent',
          color: isGoogle ? theme.palette.common.white : alpha('#fff', 0.72),
          '&:hover': {
            backgroundColor: isGoogle
              ? theme.palette.success.dark
              : alpha(theme.palette.success.main, 0.14)
          }
        }}
      >
        <GoogleIcon sx={{ fontSize: labeled ? 18 : 17 }} />
        {labeled
          ? (
            <Typography component='span' variant='body2' sx={{ fontWeight: 800, lineHeight: 1, fontSize: '0.78rem' }}>
              Google
            </Typography>
            )
          : null}
      </Button>

      <Button
        onClick={() => { onChange('n8n') }}
        variant={isN8n ? 'contained' : 'text'}
        aria-pressed={isN8n}
        aria-label='N8N data source'
        sx={{
          flex: '0 0 auto',
          backgroundColor: isN8n ? darken(theme.custom.keysys.blue, 0.18) : 'transparent',
          color: isN8n ? theme.palette.common.white : alpha('#fff', 0.72),
          '&:hover': {
            backgroundColor: isN8n
              ? darken(theme.custom.keysys.blue, 0.32)
              : alpha(theme.custom.keysys.blue, 0.14)
          }
        }}
      >
        <RobotIcon sx={{ fontSize: labeled ? 18 : 17 }} />
        {labeled
          ? (
            <Typography component='span' variant='body2' sx={{ fontWeight: 800, lineHeight: 1, fontSize: '0.78rem' }}>
              N8N
            </Typography>
            )
          : null}
      </Button>
    </ButtonGroup>
  )
}

export { SourceToggle }
